import { Settings2 } from 'lucide-react'

import { LogoMark } from '../ui/LogoMark'

export function MissingConfiguration() {
  return (
    <main className="mx-auto flex min-h-screen w-full max-w-3xl items-center px-5 py-12">
      <div className="surface-card w-full p-6 sm:p-10">
        <LogoMark />
        <span className="mt-10 grid h-12 w-12 place-items-center rounded-2xl bg-amber-100 text-amber-800">
          <Settings2 aria-hidden="true" className="h-5 w-5" />
        </span>
        <h1 className="mt-5 font-display text-3xl font-bold tracking-tight">
          Falta conectar Supabase
        </h1>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-ink/65">
          Crea <code className="rounded bg-ink/5 px-1.5 py-0.5 font-mono text-xs">.env.local</code>{' '}
          en la raíz del proyecto y configura estos valores públicos:
        </p>
        <pre className="mt-5 overflow-x-auto rounded-2xl bg-ink p-5 text-sm leading-7 text-white">
          <code>
            VITE_SUPABASE_URL=https://TU-PROYECTO.supabase.co{`\n`}
            VITE_SUPABASE_ANON_KEY=TU_CLAVE_ANON_O_PUBLISHABLE
          </code>
        </pre>
        <p className="mt-5 text-sm leading-6 text-ink/60">
          Después reinicia el servidor de desarrollo. La clave <strong>service_role</strong> nunca
          debe usarse aquí.
        </p>
      </div>
    </main>
  )
}
